import React from 'react';
function PopupPINorPOIContent({ description }) {
    return React.createElement("div", { className: "popup__desc" }, description);
}
export default React.memo(PopupPINorPOIContent);
